/*
 * WrestlingMart custom team gear form → Verus (Team gear leads).
 * Drop this into the Shopify theme (or copy the two functions) and call them
 * from the popup form. Plain browser JavaScript, no libraries.
 *
 *   1. As each logo or artwork file is picked:
 *        const up = await TeamGear.upload(file, "logo" | "artwork", (pct) => …);
 *        keep up.id; show an error from up.error if it has one.
 *   2. On Submit, once every upload has finished:
 *        const res = await TeamGear.submit({ gear: ["singlets", "other"], gearOther: "Hoodies", quantity: 41, … , fileIds });
 *        res.ok → show "Sent"; otherwise show res.error (res.field names the field, when there is one).
 *
 * Gear keys: headgear, singlets, shorts (Fight / performance shorts),
 * compression, warm_ups, bags, socks, other (then gearOther is required).
 * Files: JPG, PNG, GIF, WEBP, HEIC, SVG, TIF, PDF, AI, EPS or PSD, 50 MB each,
 * 40 a request. Required: gear, quantity, school, colors, firstName, lastName,
 * email, phone, role. Optional: state, heardFrom, designVision, emailOptIn.
 */
(function () {
  var BASE = "https://www.verus.la/api/team-gear/wrestlingmart";

  async function post(path, body) {
    try {
      var res = await fetch(BASE + path, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) });
      var json = await res.json().catch(function () { return {}; });
      return res.ok ? json : { error: json.error || "Something went wrong. Please try again.", field: json.field };
    } catch {
      return { error: "Couldn't reach us. Check your connection and try again." };
    }
  }

  /** One file, straight to storage. onProgress gets 0–100. Resolves to { id } or { error }. */
  async function upload(file, kind, onProgress) {
    var slot = await post("/uploads", { kind: kind, name: file.name, size: file.size });
    if (slot.error) return slot;
    return new Promise(function (resolve) {
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", slot.uploadUrl);
      // Exactly this type: it's part of the upload's signature.
      xhr.setRequestHeader("Content-Type", slot.contentType);
      xhr.upload.onprogress = function (e) { if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100)); };
      xhr.onload = function () { resolve(xhr.status >= 200 && xhr.status < 300 ? { id: slot.id } : { error: file.name + " didn't upload. Try again." }); };
      xhr.onerror = function () { resolve({ error: file.name + " didn't upload. Check your connection and try again." }); };
      xhr.send(file);
    });
  }

  /** The request. fields: see above; fileIds: the ids from upload(). Resolves to { ok: true } or { error, field }. */
  function submit(fields) {
    return post("", Object.assign({ pageUrl: window.location.href, website: "" }, fields));
  }

  window.TeamGear = { upload: upload, submit: submit };
})();
